export const invoicedOrdersColumns = (t: any) => [
    {
      key: "Number",
      name: t('orders.columns.orderNumber'),
      fieldName: "number",
      minWidth: 50,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "CreatedAt",
      name: t('orders.columns.orderDate'),
      fieldName: "createdAt",
      minWidth: 50,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "FinishedAt",
      name: t('orders.columns.finishedAt'),
      fieldName: "finishedAt",
      minWidth: 50,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "Company",
      name: t('orders.columns.client'),
      fieldName: "company",
      minWidth: 150,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "ReceptionPlace",
      name: t('orders.columns.receptionPlace'),
      fieldName: "receptionPlace",
      minWidth: 100,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "Operator",
      name: t('orders.columns.operator'),
      fieldName: "operator",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "Type",
      name: t('orders.columns.type'),
      fieldName: "type",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
      onRender: (item: any) => {
        const map: any = { "Pojazd": t('orders.typeValues.vehicle'), "Kontener": t('orders.typeValues.container'), "Tonaż": t('orders.typeValues.tonnage'), "Specjalne": t('orders.typeValues.special') };
        return map[item.type] !== undefined ? map[item.type] : item.type;
      },
    },
    {
      key: "Vehicle",
      name: t('orders.columns.vehicle'),
      fieldName: "vehicle",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "ContactPhone",
      name: t('orders.columns.phone'),
      fieldName: "contactPhone",
      minWidth: 50,
      maxWidth: 90,
      isResizable: true,
    },
    {
      key: "OptimaStatus",
      name: t('orders.columns.optimaStatus'),
      fieldName: "optimaStatus",
      minWidth: 50,
      maxWidth: 90,
      isResizable: true,
      onRender: (item: any) => {
        const map: any = {
          0: t('orders.optimaStatus.notSynchronized'),
          1: t('orders.optimaStatus.synchronized'),
          2: t('orders.optimaStatus.error'),
          3: t('orders.optimaStatus.manuallySynchronized'),
        };
        return map[item.optimaStatus] !== undefined ? map[item.optimaStatus] : item.optimaStatus;
      },
    },
    {
      key: "OptimaNumber",
      name: t('orders.columns.optimaNumber'),
      fieldName: "optimaNumber",
      minWidth: 50,
      maxWidth: 90,
      isResizable: true,
    },
    {
      key: "InvoiceNumber",
      name: t('orders.columns.invoiceNumber'),
      fieldName: "invoiceNumber",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "IsFromCuo",
      name: t('orders.columns.source'),
      fieldName: "isFromCuo",
      minWidth: 80,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "CuoOrderNumber",
      name: t('orders.columns.cuoOrderNumber'),
      fieldName: "cuoOrderNumber",
      minWidth: 80,
      maxWidth: 120,
      isResizable: true,
    },

  ];